<template>
  <div data-test="us-button-menu" class="us-button-menu">
    <button
      class="us-button-menu__button"
      @click="openDropdown = !openDropdown"
    >
      <slot>
        <USIcon
          name="dots"
          :diameter="buttonDiameter"
          :color="iconColor ? iconColor : 'var(--color--primary-b1)'"
          :fill="null"
        />
      </slot>
    </button>
    <USDropdownMenu
      v-if="dropdownMenuItems.length"
      id="us-button-menu-dropdown-menu"
      class="us-button-menu__dropdown-menu"
      :options="dropdownMenuItems"
      :align="dropdownMenuAlignment"
      :open="openDropdown"
      @close="openDropdown = false"
      @clickOption="handleClickOption"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'

import USIcon from '@base/components/USIcon/USIcon.vue'
import USDropdownMenu from '@base/components/USDropdownMenu/USDropdownMenu.vue'

import { DropdownAction as TypeDropdownAction } from '@base/_types/DropdownAction'

export default defineComponent({
  name: 'USButtonMenu',
  components: { USIcon, USDropdownMenu },
  props: {
    buttonDiameter: {
      type: Number,
      default: 8
    },
    dropdownMenuItems: {
      type: Array as PropType<TypeDropdownAction[]>,
      default: [] as PropType<TypeDropdownAction[]>
    },
    dropdownMenuAlignment: {
      type: String,
      default: 'right'
    },
    iconColor: { type: String, default: undefined },
    iconFill: { type: String, default: null }
  },
  emits: ['clickOption'],
  setup(props, { emit }) {
    const openDropdown = ref(false)
    const handleClickOption = (label: string, idx: number) =>
      emit('clickOption', label, idx)

    return {
      openDropdown,
      handleClickOption
    }
  }
})
</script>

<style lang="scss" scoped>
.us-button-menu {
  color: v-bind(iconColor);
  width: fit-content;
}
</style>
